import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  SimpleChanges
} from '@angular/core';

@Component({
  selector: 'app-generic-drop-down',
  templateUrl: './generic-drop-down.component.html',
  styleUrls: ['./generic-drop-down.component.scss'],
})
export class GenericDropDownComponent {
  @Output() value = new EventEmitter<string>();
  @Output() index = new EventEmitter<number>();
  @Input() label? = '';
  @Input() options: any;
  @Input() title!: string;
  @Input() titleName: string = '';
  @Input() valueName!: string;
  @Input() captionItem!: string;
  @Input() showDropContainerTop = false;
  @Input() createWorkspaceFlag: boolean = false;
  @Input() disabled = false;
  @Input() hasCaption: boolean = false;
  showDropDownOptions: boolean = false;
  icon = '';
  @Input() shouldEmitdisplayValue: boolean = false;
  @Input() shouldEmitIndex: boolean = false;
  @Input() shouldEmitEmittedValue: boolean = false;
  @Input() shouldEmitOption: boolean = false;
  @Input() shouldEmitDisplayValueAndEmittedValue!: boolean;
  @Input() isButton: boolean = false;
  activeIndex: number | null = null;
  loaderView: boolean = true;
  styleObject = {
    backgroundColor: '#2196f3',
    minWidth: '150px',
    display: 'flex',
    justifyContent: 'center'
  };
  constructor(private elementRef: ElementRef) { }
  ngOnInit(): void { }
  ngOnChanges(changes: SimpleChanges) {
    this.loaderView = true
    if (changes['options']) {
      const newOptions = changes['options'].currentValue;
      if (newOptions && newOptions.length > 0) {
        this.loaderView = false;
      } else {
        this.loaderView = true
      }
    }
  }

  @HostListener('document:click', ['$event.target'])
  public onPageClick(targetElement: any) {
    const clickedInside = this.elementRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.showDropDownOptions = false
    }
    this.showOptions();
  }

  showOptions(): void {
    if (this.disabled) {
      this.showDropDownOptions = false;
      return;
    }
  }
  toggleDropdown() {
    this.showDropDownOptions = !this.showDropDownOptions;
  }
  getOption(
    displayValue: string,
    index: number,
    emitValue: string,
    option: string
  ): void {
    if (this.disabled) return;
    this.activeIndex = index;
    displayValue === undefined
      ? (this.title = option)
      : (this.title = displayValue);
    this.showDropDownOptions = false;
    if (this.shouldEmitdisplayValue) {
      this.value.emit(displayValue); //value to be displayed in the title and options
    }
    if (this.shouldEmitOption) {
      this.value.emit(option);//when only  array of strings is passed
    }
    if (this.shouldEmitIndex) {
      this.index.emit(index); //index of the object that has been selected from array
    }
    if (this.shouldEmitEmittedValue) {
      this.value.emit(emitValue); //the value of the option
    }
    if (this.shouldEmitDisplayValueAndEmittedValue) {
      this.value.emit(displayValue + '  ' + emitValue);
    }
  }
}